import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { WhatsAppIcon } from './WhatsAppButton';

const SOCIALS = [
  { icon: WhatsAppIcon, href: 'https://wa.me/905412665154', label: 'WhatsApp' },
];

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const goToSection = (id) => {
    if (location.pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollTo: id } });
    }
  };

  return (
    <footer className="bg-bg-primary border-t border-border-soft pt-14 sm:pt-20 pb-8 sm:pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 sm:gap-12 mb-10 sm:mb-16">
          <div className="space-y-4">
            <span className="text-white font-bold tracking-tight text-lg">
              ÖNCÜ <span className="text-accent-red">BOYA</span>
            </span>
            <p className="text-text-muted text-sm font-light leading-relaxed max-w-xs">
              25 yıldan beri Tekkeköy'de araç boyama ve boya ürünleri alanında güvenilir hizmet sunan işletmedir.
            </p>
            <div className="flex items-center gap-3 pt-2">
              {SOCIALS.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-10 h-10 rounded-full border border-border-soft flex items-center justify-center text-text-muted hover:text-accent-gold hover:border-accent-gold transition-colors duration-500"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-white tracking-widest text-sm uppercase mb-5">Bağlantılar</h4>
            <ul className="space-y-3 text-sm text-text-muted font-light">
              <li><button onClick={() => goToSection('services')} className="hover:text-accent-gold transition-colors duration-300">Hizmetler</button></li>
              <li><Link to="/urunler" className="hover:text-accent-gold transition-colors duration-300">Ürünler</Link></li>
              <li><button onClick={() => goToSection('about')} className="hover:text-accent-gold transition-colors duration-300">Hakkımızda</button></li>
              <li><button onClick={() => goToSection('contact')} className="hover:text-accent-gold transition-colors duration-300">İletişim</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white tracking-widest text-sm uppercase mb-5">İletişim</h4>
            <ul className="space-y-3 text-sm text-text-muted font-light">
              <li><a href="tel:+905412665154" className="hover:text-accent-gold transition-colors duration-300">+90 541 266 51 54</a></li>
              <li><a href="https://maps.google.com" target="_blank" rel="noopener noreferrer" className="hover:text-accent-gold transition-colors duration-300">Şabanoğlu, 75. Sk. No: 11/1, Tekkeköy/Samsun</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white tracking-widest text-sm uppercase mb-5">Çalışma Saatleri</h4>
            <p className="text-text-muted text-sm font-light leading-relaxed">
              Pazartesi - Cumartesi<br />
              08:00 - 18:00<br />
              <span className="text-accent-red">Pazar Kapalı</span>
            </p>
          </div>
        </div>

        <div className="border-t border-border-soft pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-text-muted text-sm font-light text-center sm:text-left">
            © 2026 Öncü Boya — Tekkeköy, Samsun. Tüm hakları saklıdır.
          </p>
          <Link to="/admin" className="text-text-muted/50 hover:text-accent-gold transition-colors duration-300 text-sm" aria-label="Yönetici Paneli">
            ⚙
          </Link>
        </div>
      </div>
    </footer>
  );
}
